import * as mapFromApiFunctions from './mapFromApi';
import * as mapToApiFunctions from './mapToApi';

export const mapFromApi = mapFromApiFunctions;
export const mapToApi = mapToApiFunctions;
